<template>
  <div v-if="open" class="tx-modal-backdrop" @click.self="close">
    <div class="tx-modal" role="dialog" aria-modal="true">
      <header class="tx-modal__head">
        <div>
          <h3>Statik mətni dəyiş</h3>
          <code class="key">{{ activeKey }}</code>
        </div>
        <button type="button" class="close" @click="close" aria-label="Close">×</button>
      </header>

      <div class="tx-modal__body">
        <p v-if="error" class="err">{{ error }}</p>
        <label class="fld" v-for="l in langs" :key="l">
          <span>{{ l.toUpperCase() }}</span>
          <textarea v-model="values[l]" rows="2"></textarea>
        </label>
      </div>

      <footer class="tx-modal__foot">
        <button type="button" class="ghost" :disabled="saving" @click="close">Ləğv et</button>
        <button type="button" class="primary" :disabled="saving" @click="save">
          {{ saving ? 'Yadda saxlanır…' : 'Yadda saxla' }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const LANGS = ["az", "de", "en", "ru", "tr"];

export default {
  name: "StaticEditorModal",
  data() {
    return {
      open: false,
      activeKey: "",
      values: { az: "", de: "", en: "", ru: "", tr: "" },
      saving: false,
      error: null,
      langs: LANGS,
    };
  },
  mounted() {
    this.handler = (ev) => this.onOpen(ev.detail && ev.detail.key);
    window.addEventListener("tx-edit-open", this.handler);
  },
  beforeDestroy() {
    if (this.handler) window.removeEventListener("tx-edit-open", this.handler);
  },
  methods: {
    async onOpen(key) {
      if (!key) return;
      this.activeKey = key;
      this.error = null;
      // İlkin dəyərlər: statics-dən cari dildəki dəyəri al, qalan dilləri boş başla.
      // Daha dəqiq dəyərlər üçün backend-dən GET edək (gethome yalnız cari dil qaytarır).
      const cur = this.$store.state.statics && this.$store.state.statics[key];
      this.values = { az: "", de: "", en: "", ru: "", tr: "" };
      this.values[this.$store.state.lang || "az"] = cur || "";
      this.open = true;
      // Bütün dilləri serverdən çəkməyə cəhd et (admin GET /translations endpoint mövcuddur).
      try {
        const res = await axios.get(`/translations`);
        const list = res.data || [];
        const row = Array.isArray(list) ? list.find((t) => t.key === key) : null;
        if (row) {
          this.values = {
            az: row.value_az || "", de: row.value_de || "", en: row.value_en || "",
            ru: row.value_ru || "", tr: row.value_tr || "",
          };
        }
      } catch { /* admin GET 401 ola bilər — fallback işləyir */ }
    },
    close() {
      if (this.saving) return;
      this.open = false;
      this.activeKey = "";
      this.error = null;
    },
    async save() {
      if (!this.activeKey) return;
      this.saving = true;
      this.error = null;
      try {
        await axios.put(`/translation/inline/${encodeURIComponent(this.activeKey)}`, {
          value_az: this.values.az || "",
          value_en: this.values.en || "",
          value_de: this.values.de || "",
          value_ru: this.values.ru || "",
          value_tr: this.values.tr || "",
        });
        // Cari dilə görə statics-i yenilə → səhifə dərhal dəyişir
        const lang = this.$store.state.lang || "az";
        this.$store.commit("patchStatic", { key: this.activeKey, value: this.values[lang] || "" });
        if (this.$toast) this.$toast.success("Yadda saxlanıldı");
        this.open = false;
      } catch (e) {
        const code = e?.response?.status;
        if (code === 403) this.error = "İcazə yoxdur (yalnız xüsusi user redaktə edə bilər).";
        else if (code === 401) this.error = "Sessiya bitib — yenidən daxil olun.";
        else this.error = e?.response?.data?.message || "Yadda saxlanmadı.";
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tx-modal-backdrop {
  position: fixed; inset: 0; background: rgba(15,23,42,0.55); z-index: 3500;
  display: flex; align-items: center; justify-content: center; padding: 1rem;
}
.tx-modal {
  width: 100%; max-width: 560px; max-height: 90vh; background: #fff; border-radius: 14px; box-shadow: 0 12px 32px rgba(15,23,42,0.25);
  display: flex; flex-direction: column; overflow: hidden;
}
.tx-modal__head { display: flex; align-items: center; justify-content: space-between; gap: 1rem; padding: 1rem 1.25rem; border-bottom: 1px solid #eef0f4;
  h3 { margin: 0; font-size: 1rem; color: #1e3c72; }
  .key { display: inline-block; margin-top: 4px; font-size: 0.78rem; color: #64748b; background: #f1f6ff; border: 1px solid #dbe6f5; padding: 1px 6px; border-radius: 4px; }
  .close { background: transparent; border: 0; font-size: 1.5rem; line-height: 1; color: #64748b; cursor: pointer; &:hover { color: #1e3c72; } }
}
.tx-modal__body { padding: 1rem 1.25rem; overflow-y: auto;
  .err { background: #fdecea; color: #c0392b; padding: 0.55rem 0.75rem; border-radius: 6px; font-size: 0.85rem; margin: 0 0 0.75rem; border: 1px solid #f1c2bd; }
  .fld { display: block; margin-bottom: 0.75rem;
    span { display: block; font-size: 0.72rem; font-weight: 700; color: #475569; letter-spacing: 0.04em; margin-bottom: 0.25rem; }
    textarea { width: 100%; min-height: 56px; padding: 0.55rem 0.75rem; border: 1px solid #d0d5dd; border-radius: 6px; font: inherit; font-size: 0.88rem; outline: none; resize: vertical;
      &:focus { border-color: #2a5298; }
    }
  }
}
.tx-modal__foot { display: flex; justify-content: flex-end; gap: 0.5rem; padding: 0.75rem 1.25rem; border-top: 1px solid #eef0f4; background: #f8fafc;
  .ghost { background: #fff; border: 1px solid #d0d5dd; color: #475569; padding: 0.5rem 1rem; border-radius: 6px; font: inherit; font-size: 0.85rem; font-weight: 600; cursor: pointer;
    &:hover:not(:disabled) { background: #f7f9fc; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
  }
  .primary { background: #2a5298; border: 0; color: #fff; padding: 0.5rem 1.1rem; border-radius: 6px; font: inherit; font-size: 0.85rem; font-weight: 600; cursor: pointer;
    &:hover:not(:disabled) { background: #1e3c72; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
  }
}
</style>
